import { createSlice } from "@reduxjs/toolkit";

// ✅ Safely parse stored data
const storedAdmin = localStorage.getItem("mcollectadmin")
  ? JSON.parse(localStorage.getItem("mcollectadmin"))
  : null;

const initialState = {
  isAuthenticated: !!storedAdmin,
  loginData: storedAdmin || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.isAuthenticated = true;
      state.loginData = action.payload;

      // ✅ Store as JSON
      localStorage.setItem("mcollectadmin", JSON.stringify(action.payload));
    },

    logout(state) { 
      state.isAuthenticated = false;
      state.loginData = null;
      localStorage.removeItem("mcollectadmin");
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
